import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {environment} from "../../../environments/environment";

@Injectable({
  providedIn: 'root',
})
export class TranslationService {
  private availableLanguages: string[] = ['es', 'en', 'fr', 'de', 'nl'];

  constructor(private translate: TranslateService) {

    const savedLang = localStorage.getItem('selectedLanguage') || environment.lang;

    this.setLanguage(savedLang);
  }

  getAvailableLanguages(): string[] {

    if(environment.availableLanguages) {
      return environment.availableLanguages;
    } else {
      return this.availableLanguages;
    }

  }

  setLanguage(lang: string): void {
    if (this.availableLanguages.includes(lang)) {
      this.translate.use(lang);
      localStorage.setItem('selectedLanguage', lang);
    }
  }

  getCurrentLanguage(): string {
    return localStorage.getItem('selectedLanguage') || 'es';
  }
}
